import React from "react";
import { useTranslation } from "react-i18next";
import { OrderItemData } from "../../../../../../../../../services/Api/Public/types";
import ItemListItem from "./ItemListItem";

interface ItemsListProps {
	items?: OrderItemData[];
}

export const ItemsList = ({ items }: ItemsListProps): JSX.Element | null => {
	const { t } = useTranslation();

	if (!items || items.length === 0) {
		return null;
	}

	return (
		<section data-testid="e-order-order-details-items-list">
			<ul>
				{items.map((item) => {
					const key = `${item.product?.name ?? t("modules.e_order.field.no_name_product.title")}${
						item.quantity
					}${item.total_price.amount}${item.unit_price.amount}`;

					return <ItemListItem item={item} key={key} />;
				})}
			</ul>
		</section>
	);
};
